import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"

import { cn } from "lib/utils"

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default:
          "border-[var(--primary-action)] bg-[var(--primary-action)] text-white hover:bg-[var(--primary-action-hover)] border-transparent",
        secondary:
          "border-blue-200 bg-blue-100 text-blue-700 hover:bg-blue-200 border-transparent",
        destructive:
          "border-red-600 bg-red-600 text-white hover:bg-red-700 border-transparent",
        outline:
          "border-gray-300 bg-white text-gray-700 hover:bg-gray-100 border-transparent",
        warning:
          "border-[#ffba00] bg-[#ffba00] text-black hover:opacity-90 border-transparent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}) {
  const Comp = asChild ? Slot : "span"

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }